export default __webpack_public_path__ + "static/media/Combined Shape.ba0b1dd0.svg";